<template>
	<div v-if="$vuetify.breakpoint.lgAndUp">
		<v-menu offset-y close-on-click style="overflow-y: auto !important">
			<template #activator="{ on, attrs }">
				<v-list-item v-bind="attrs" v-on="on">
					<v-list-item-avatar v-if="!imageObj.logo" horizontal>
						<v-img :src="no_avatar"></v-img>
					</v-list-item-avatar>
					<!-- <div v-else> -->
					<!-- <v-menu v-model="showNotificationMenu" :position-x="notificationMenu_x" :position-y="notificationMenu_y" absolute>
							<v-card min-width="300">
								<v-card-title class="justify-center text-center pb-1 mb-0">Notifications</v-card-title>
							</v-card>
						</v-menu>
						<v-badge v-if="notificationCount > 0" bordered overlap bottom offset-x="35" offset-y="25" color="primary" @click="doShowNotificationMenu">
							<template #default>
								<v-list-item-avatar horizontal @click="doShowNotificationMenu">
									<v-img :src="imageObj.logo"></v-img>
								</v-list-item-avatar>
							</template>
							<template #badge @click="doShowNotificationMenu">
								<v-icon v-if="notificationIcon" class="shakey" @click="doShowNotificationMenu">{{ notificationIcon }}</v-icon>
								<p v-else @click="doShowNotificationMenu">{{ notificationCount }}</p>
							</template>
						</v-badge> -->
					<v-list-item-avatar v-else horizontal>
						<v-img :src="imageObj.logo"></v-img>
					</v-list-item-avatar>
					<!-- </div> -->

					<v-list-item-content @click="showUserMenu">
						<v-list-item-title v-if="user" :style="`color: ${customColor} !important;`" color="red" class="text--secondary font-weight-bold">{{
							usersName
						}}</v-list-item-title>
						<v-list-item-subtitle :style="`color: ${customColor} !important;`">{{ usersProfession }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</template>

			<!-- <v-menu v-model="userMenu" offset-y close-on-click :position-x="userMenu_x" :position-y="userMenu_y" absolute max-height="412"> -->
			<v-card elevation="3" style="overflow-y: hidden !important; overflow-x: hidden !important">
				<v-card-actions>
					<v-row>
						<v-col>
							<v-row v-if="showWallet" class="pb-0 ml-1 mr-1 ma-3">
								<v-btn :disabled="profileDisabled" dark color="wallet" block @click="openWallet">Redeem Credits</v-btn>
							</v-row>
							<v-row class="pb-0 ml-1 mr-1 mb-3 ma-3"
								><v-btn :disabled="profileDisabled" to="/company/profile" router color="secondary" block @click="handleEditProfile">Edit Profile</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :disabled="accountDisabled" color="secondary" block @click="handleAccountSettings">Account Settings</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :disabled="accountDisabled" color="secondary" block to="/company/user-management">User Management</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" router :href="menuLinks.faq" target="_blank" color="secondary" block>FAQ</v-btn></v-row>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :loading="apiRequest" router :href="menuLinks.blog" target="_blank" color="secondary" block>Blog</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"
								><v-btn :loading="apiRequest" router :href="menuLinks.contact" target="_blank" color="secondary" block>Contact Us</v-btn></v-row
							>
							<v-row class="pb-0 ml-1 mr-1 ma-3"><v-btn :loading="apiRequest" color="secondary" block @click="signOut">Sign Out</v-btn></v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
			<!-- </v-menu> -->
		</v-menu>
	</div>
</template>

<script>
import store from '@/store';
import axios from 'axios';
import { bus } from '@/main';

import { authSignOut, resolveContactHref } from '@utils';

export default {
	name: 'PracNavDrawerDesktop',
	props: {
		customColor: { type: String, default: '#203843' },
		profileDisabled: { type: Boolean, default: false },
		accountDisabled: { type: Boolean, default: false },
		showWallet: { type: Boolean, default: false },
	},
	data: () => ({
		user: null,
		first_name: null,
		apiRequest: false,
		notification: true,
		showNotificationCount: false,
		notificationCount: 0,
		showNotificationMenu: false,
		userMenu: false,
		userMenu_x: 0,
		userMenu_y: 0,
		notificationMenu_x: 0,
		notificationMenu_y: 0,
		imageObj: {
			logo: null,
		},
		no_avatar: require('@/assets/images/avatars/user.png'),
	}),

	computed: {
		notificationIcon() {
			if (this.notification) {
				return this.showNotificationCount ? false : 'notifications_active';
			} else {
				return 'notifications';
			}
		},
		usersProfession() {
			if ('profession' in store.getters.user) {
				return store.getters.user.profession;
			} else if ('industry' in store.getters.company) {
				return store.getters.company.industry;
			} else {
				return null;
			}
		},

		usersName() {
			if ('first_name' in store.getters.user) {
				return store.getters.user.first_name;
			} else if ('name' in store.getters.user) {
				return store.getters.user.name;
			} else {
				return null;
			}
		},

		menuLinks() {
			return {
				faq: this.tenant.settings.links.faq || this.tenant.settings.brandUrl + '/faq',
				blog: this.tenant.settings.links.blog || this.tenant.settings.brandUrl + '/blog',
				contact: resolveContactHref(this.tenant.settings.links, this.tenant.settings.brandUrl),
			};
		},
	},

	async created() {
		this.user = store.getters.user;
		this.toggleNotificationCount(this);
		await this.getImages(this.imageObj);
	},

	methods: {
		handleAccountSettings() {
			this.apiRequest = true;
			this.$router.push('/company/account-settings');
		},
		handleEditProfile() {
			this.apiRequest = true;
			this.$router.push('/company/profile');
		},
		async getImages(imageObj) {
			try {
				const token = store.getters.jwtToken;
				let imageArr = store.getters.company?.documents?.images;
				const images = Object.keys(imageObj);
				for (let image of images) {
					if (imageArr?.includes(image)) {
						let res = await axios.get(store.getters.getDOCUMENTS + `/images/${image}/` + store.getters.company.id, { headers: { Authorization: token } });
						if (res.status === 200) {
							imageObj[image] = 'data:image/png;base64,' + res.data.data;
						}
					}
				}
			} catch (err) {
				console.error(err);
			}
		},

		doShowNotificationMenu(e) {
			e.preventDefault();
			this.showNotificationMenu = true;
			this.showNotificationMenu = false;
			this.notificationMenu_x = e.clientX;
			this.notificationMenu_y = e.clientY;
			this.$nextTick(() => {
				this.showNotificationMenu = true;
			});
		},
		showUserMenu(e) {
			e.preventDefault();
			this.userMenu = false;
			this.userMenu_x = e.clientX;
			this.userMenu_y = e.clientY;
			this.$nextTick(() => {
				this.userMenu = true;
			});
		},
		toggleNotificationCount(vue) {
			vue.showNotificationCount = !vue.showNotificationCount;
			setTimeout(
				vue => {
					vue.toggleNotificationCount(vue);
				},
				vue.showNotificationCount ? 2050 : 1000,
				this
			);
		},
		async signOut() {
			this.apiRequest = true;
			await authSignOut();
			this.apiRequest = false;
		},
		openWallet() {
			bus.$emit('show-wallet-dialog');
		},
	},
};
</script>
